import constants from '../../constants';

const getCssVariablesMap = (cssText) => {
  const cssVariablesMap = cssText.split(';').reduce((map, propertyRule) => {
    if (!propertyRule.trim()) return map;

    const [prop, value] = propertyRule.split(':');
    return {
      ...map,
      [prop.trim()]: value.trim(),
    };
  }, {});

  return cssVariablesMap;
};

export default getCssVariablesMap;
